import { DivIcon } from 'leaflet';
import { arteliaColors } from '../theme';

const iconCache = new Map<string, DivIcon>();

/**
 * Create a custom marker icon with caching for performance
 */
function createMarkerIcon(role: string, isSelected: boolean = false): DivIcon {
  const isBooster = role === 'Booster';
  const baseColor = isBooster ? arteliaColors.greenDarker : arteliaColors.bluePrimary;
  const size = isSelected ? 16 : 12;
  
  return new DivIcon({
    html: `
      <div style="
        width: ${size}px;
        height: ${size}px;
        background: ${baseColor};
        border: 2px solid white;
        border-radius: 50%;
        box-shadow: 0 2px 4px rgba(0, 93, 131, 0.4);
        ${isSelected ? 'transform: scale(1.3); border-width: 3px;' : ''}
        transition: all 0.2s ease;
      "></div>
    `,
    className: `ambassador-marker ${isBooster ? 'booster' : ''} ${isSelected ? 'selected' : ''}`,
    iconSize: [size, size],
    iconAnchor: [size / 2, size / 2],
  });
}

/**
 * Get cached icon or create new one if not exists
 */
export function getIcon(role: string, isSelected: boolean = false): DivIcon {
  const key = `${role}-${isSelected}`;
  
  if (!iconCache.has(key)) {
    iconCache.set(key, createMarkerIcon(role, isSelected));
  }
  
  return iconCache.get(key)!;
}

/**
 * Clear icon cache - call on component unmount to prevent memory leaks
 */
export function clearIconCache(): void {
  iconCache.clear();
}

/**
 * Get cache size for debugging
 */
export function getCacheSize(): number {
  return iconCache.size;
}